import { createBackground, deleteBackground, editBackground, getBackgroundsPerPage, reorderBackgrounds, updateBackground } from '../../actions/backgrounds';
import { createDecoration, deleteDecoration, editDecoration, getDecorationsPerPage, reorderDecorations, updateDecoration } from '../../actions/decorations';
import { createOverlay, deleteOverlay, editOverlay, getOverlaysPerPage, reorderOverlays, updateOverlay } from '../../actions/overlays';
import { validateBackground, validateDecoration, validateOverlay } from '../../validation';
import BackgroundForm from '../backgrounds/BackgroundForm';
import DecorationForm from '../decorations/DecorationForm';
import OverlayForm from '../overlays/OverlayForm';

// The item kinds of a pack page's list tabs, keyed by tab key (packNav's PACK_TABS).
export const PACK_KINDS = {
  fonds: {
    addTitle: 'Nouveau fond',
    imageFolder: 'backgrounds',
    formName: 'backgroundForm',
    Form: BackgroundForm,
    select: (state) => ({ items: state.backgrounds?.backgrounds ?? [], itemsCount: state.backgrounds?.count, selected: state.backgrounds?.background }),
    getPerPage: getBackgroundsPerPage,
    reset: () => ({ type: 'GET_BACKGROUNDS', backgrounds: [], count: 0 }),
    create: createBackground,
    edit: editBackground,
    update: updateBackground,
    delete: deleteBackground,
    reorder: reorderBackgrounds,
    validate: validateBackground,
  },
  decorations: {
    addTitle: 'Nouvelle décoration',
    imageFolder: 'decorations',
    formName: 'decorationForm',
    Form: DecorationForm,
    select: (state) => ({ items: state.decorations?.decorations ?? [], itemsCount: state.decorations?.count, selected: state.decorations?.decoration }),
    getPerPage: getDecorationsPerPage,
    reset: () => ({ type: 'GET_DECORATIONS', decorations: [], count: 0 }),
    create: createDecoration,
    edit: editDecoration,
    update: updateDecoration,
    delete: deleteDecoration,
    reorder: reorderDecorations,
    validate: validateDecoration,
  },
  emojis: {
    addTitle: 'Nouvel emoji',
    imageFolder: 'overlays',
    formName: 'overlayForm',
    Form: OverlayForm,
    select: (state) => ({ items: state.overlays?.overlays ?? [], itemsCount: state.overlays?.count, selected: state.overlays?.overlay }),
    getPerPage: getOverlaysPerPage,
    reset: () => ({ type: 'GET_OVERLAYS', overlays: [], count: 0 }),
    create: createOverlay,
    edit: editOverlay,
    update: updateOverlay,
    delete: deleteOverlay,
    reorder: reorderOverlays,
    validate: validateOverlay,
  },
};
